function isMergeable(obj) {
    const stringValue = Object.prototype.toString.call(obj);
    const isSpecial =
        stringValue === '[object RegExp]' ||
        stringValue === '[object Date]' ||
        stringValue === '[object Function]' ||
        stringValue === '[object Array]';
    return !!obj && typeof obj === 'object' && !isSpecial;
}

export function deduplicate(array, keyGetter = (item) => item) {
    const keyedItems = {};
    const orderPreservedArray = [];
    for (const item of array) {
        const key = keyGetter(item);
        if (typeof keyedItems[key] === 'undefined') {
            keyedItems[key] = item;
            // must also be pushed to an array as hashmaps are unordered
            orderPreservedArray.push(item);
        }
    }
    return orderPreservedArray;
}

export function deepClone(obj) {
    const isArray = Array.isArray(obj);
    let newObj = obj;
    if (isArray) {
        newObj = [];
        for (const item of obj) {
            let newItem = item;
            if (isMergeable(item) || Array.isArray(item)) {
                newItem = deepClone(item);
            }
            newObj.push(newItem);
        }
    } else if (isMergeable(obj)) {
        newObj = {};
        for (const [key, value] of Object.entries(obj)) {
            let newValue = value;
            if (isMergeable(value) || Array.isArray(value)) {
                newValue = deepClone(value);
            }
            newObj[key] = newValue;
        }
    }
    return newObj;
}

export function capitalizeString(str) {
    return str?.charAt(0).toUpperCase() + str?.substr(1).toLowerCase();
}
